export const USER_ROLES = [
    'superadmin',
    'admin',
    'manager',
    'cashier',
    'waiter',
];
//# sourceMappingURL=types.js.map